import { PropsWithChildren } from "react";

import Intro from "@/components/typography/Intro";
import H3 from "@/components/typography/H3";
import Button from "@/components/furniture/Button";

import { typogrify } from "@/utils/string";

type SectionWrapperProps = {
  title?: string;
  text?: string;
  linkText?: string;
  link?: string;
};

const SectionWrapper = ({
  title,
  text,
  linkText,
  link,
  children,
}: PropsWithChildren<SectionWrapperProps>) => {
  return (
    <div className="flex flex-col gap-12">
      {!!(!!title || !!text) && (
        <header className="text-center flex flex-col gap-8 max-w-rich-text">
          {!!title && <H3 as="h2">{typogrify(title)}</H3>}
          {!!text && <Intro as="p">{typogrify(text)}</Intro>}
        </header>
      )}

      {children}

      {!!linkText && (
        <footer className="text-center  max-w-rich-text">
          <Button variant="outline" href={link || ""}>
            {linkText}
          </Button>
        </footer>
      )}
    </div>
  );
};

export default SectionWrapper;
